// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import AppsAssignConnection from './data'

export default function AppsAssignConnectionFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/AppsAssignConnection">
      <AppsAssignConnection {...props}>
        {children}
      </AppsAssignConnection>
    </Flow>
  )
}
